// Main App Store Module

import CfgApp from "@/assets/cfg/CfgApp.json";
import CfgAppDemo from "@/assets/cfg/CfgAppDemo.json";
import * as Utils from "@/utils/utils.js";
import * as ApiUtils from "@/utils/api_utils.js";
import * as PixUtils from "@/utils/pix_utils.js";
import * as Classes from "@/classes/classes";
import { m } from "@/utils/utils.js";

const state = {
	debug: CfgApp.debug,
	appVersion: CfgApp.appVersion,
	appDate: CfgApp.appDate,
	ready: false,
	initTasksPassed: [],
	role: CfgApp.role,
	firstSearch: true,
	cats: [],
	arts: [],
	pager: {
		btnsPerSet: CfgApp.pager.btnsPerSet,
		recsPerPage: CfgApp.pager.recsPerPage,
		curPage: 1,
		begRec: 0,
		endRec: 0,
		qtyRecs: 0,
		totRecs: 0,
	},
	search: {
		cat: {},
		keyword: "",
		dateBeg: "",
		dateEnd: "",
	},
	result: {
		cat: {},
		keyword: "",
		dateBeg: "",
		dateEnd: "",
	},
	upload: {
		cat: null,
		art: null,
		pix: [],
	},
	current: {
		cat: null,
		art: null,
		pix: [],
	},
	contact: {
		name: "",
		email: "",
		subj: "",
		messText: "",
	},
	stats: {
		cols: [],
		rows: [],
	},
	trxStatus: [],
	animal: "dog",
};

const getters = {
	state: state => {return state}, // this whole namespaced state
	debug: state => {return state.debug}, // debug flags
}

const mutations = {
	
	mutToggleDebugConsoleMess: (state, payload) => {
		m("mut toggle debug console mess");
		state.debug.showConsoleMess = !state.debug.showConsoleMess;
	},

	mutToggleRole: (state, payload) => {
		m("mut toggle role");
		state.role = (state.role=="usr")? "adm": "usr";
	},

	mutSetStats: (state, payload) => {
		m("mut set stats");
		state.stats = {
			cols: payload.cols,
			rows: payload.rows,
		}
		m("state", state);
	},

	mutSetContact: (state, payload) => {
		m("mut set contact", payload);
		state.contact.name = payload.rec.name || "";
		state.contact.email = payload.rec.email || "";
		state.contact.subj = payload.rec.subj || "";
		state.contact.messText = payload.rec.messText || "";
		m("state", state);
	},
	mutClearStep: (state, payload) => {
		m("mut clear step", payload);
		const {step} = payload;
		state[step].art = new Classes.ArtRec();
		state[step].cat = state.cats[0];
		state[step].pix = [];
		m("state", state);
	},

	// Update Transaction Status
	mutUpdTrxStatus(state, payload) {
		m("mut upd trx status", payload);
		if (payload.trx=="clear") {
			state.trxStatus = [];
		} else {
			state.trxStatus.push ({
				step: payload.step,
				trx: payload.trx,
				mess: payload.mess,
			});
		}
		m("trx status", state.trxStatus);
	},

	// Update Pic Rec 
	mutUpdPicRec(state, payload) {
		m("mutUpdPicRec", payload);
		const {step, rec} = payload;

		rec.testObj.updTime = Utils.getNow();
		state[step].pix.splice(rec.sortKey, 1, rec);
		// state[step].pix[rec.imgIdx] = rec;
	},


	// Add pic record to pix array
	mutAddPicRec(state, payload) {
		m("mutAddPicRec", payload);
		const {step, rec} = payload;
		rec.sortKey = state[step].pix.length;
		if (state[step].pix.length==0) rec.primary = true; 
		state[step].pix.push(rec);
	},

	
	// Delete record of pix array
	mutDelPic(state, payload) {
		const {step, idx} = payload;
		if (idx >=0 && idx < state[step].pix.length) {
			state[step].pix.splice([idx],1);
		}
	},
	
	
	// Recalc sort keys for pix records array
	mutCalcSortKeys(state, payload) {
		m("mutCalcSortKeys");
		const { step } = payload;
		for (var i=0; i<state[step].pix.length; i++) {
			state[step].pix[i].sortKey = i;
		}
	},


	mutCalcPrimaryPic (state, payload) {
		const { step } = payload;
		m("mutCalcPrimaryPic", step)

		// Check main pix item id
		let ok = false;
		for (let i=0; i<state[step].pix.length; i++) {
			let item = state[step].pix[i];
			item.primary = (item.itemId == state[step].art.pixId);	
			if (item.primary) {
				state[step].art.mainIdx = i;
				ok = true;
			}
		}

		// Default if none
		if (!ok) {
			state[step].art.mainIdx = 0;
			if (state[step].pix.length>0) {
				state[step].art.pixId = state[step].pix[0].itemId;
				state[step].pix[0].primary = true;
			} else {
				state[step].art.pixId = "";
			}
		}

		m("mutCalcPrimaryPic end");
		m("art", state[step].art);
		m("pix", state[step].pix);

	},


	mutSetPicFlag (state, payload) {
		m("app mut set pic flag", payload);
		const { step, idx, flagName } = payload;

		if (flagName=='primary') {
			state[step].art.pixId = state[step].pix[idx].itemId;
			state[step].art.mainIdx = idx;
		}
		if (flagName=='merit') {
			state[step].pix[idx].merit = (state[step].pix[idx].merit == 'ok')? '': 'ok';
		}
		if (flagName=='live') {
			state[step].pix[idx].live = (state[step].pix[idx].live == '1')? '': '1';
		}

	},


	// Change Order of pix
	mutMovePic (state, payload) {
		m("app mut move pic", payload);

		const { step, idx, amount } = payload;

		var newPos = idx + amount;
		if (newPos >=0 && newPos < state[step].pix.length) {
			const removed = state[step].pix.splice([idx],1);
			state[step].pix.splice([newPos], 0, removed[0]);
		}
	},


	// Set Animal
	mutSetAnimal: (state, item) => {
		state.animal = item;
	},

	
	// Set Search Result values 
	mutSetSearchResult: (state, payload) => {
		m("app mut set search result", payload);
		for (let key of Object.keys(payload)) {
			state.result[key] = payload[key];
		}
	},

	// Set Search values 
	mutSetSearch: (state, payload) => {
		m("app mut set search", payload);
		for (let key of Object.keys(payload)) {
			state.search[key] = payload[key];
		}
	},

	// Set Pager values 
	mutSetPager: (state, payload) => {
		m("app mut set pager", payload);
		for (let key of Object.keys(payload)) {
			state.pager[key] = payload[key];
		}
	},


	// Set Article ==========
	mutSetArt: (state, payload) => {

		m("app mut set art", payload);
		let step = payload.step || "current";
		let newArt = new Classes.ArtRec(payload.art);
		m("newArt", newArt);
		state[step].art = newArt;
		state[step].cat = newArt.cat;
		m("app mut up art is now", step, newArt);
		m("app mut state", state);

	},

	// Set Category ==========
	mutSetCat: (state, payload) => {
		const step = payload.step || "current";
		const cat = payload.cat || state.cats[0];
		m("app mut set cat: " + step, cat);
		state[payload.step].cat = {...cat};	

		m("app mut state", state);
	},


	// Load cats list ==========
	mutLoadCats: (state, payload) => {
		m("app mut load cats", payload);
		let list = payload.list || [];
		state.cats = list.map( (item) => {
			const rec = new Classes.CatRec(item);
			return rec;
		});
	},


	// Load Articles list
	mutLoadArts: (state, payload={}) => {
		m("app mut load arts", payload);
		let list = payload.list || [];
		state.firstSearch = false;
		state.arts = list.map( (item) => {
			const rec = new Classes.ArtRecFromDB(item);
			// m("rec", rec);
			return rec;
		});
		m("arts is now", state.arts);
	},


	// Load Pix from list
	mutLoadPix: (state, payload={}) => {
		m("app mutation: set pix", payload);
		let step = payload.step || "current";
		let list = payload.list || [];

		state[step].pix = list.map( (item) => {
			const rec = new Classes.PicRecFromDB(item);
			m("rec", rec);
			return rec;
		});
	},

	
	// Check Inital Task list
	mutInitTaskPass: (state, task_id) => {
		m("app mut init task pass", task_id);
		if (!state.initTasksPassed.includes(task_id)) state.initTasksPassed.push(task_id);
	},


	// Initialize values
	mutInit: (state, payload) => {
		m("app mut init");

		// Init cat with first cat rec
		for (let item of state.cats) {
			if (item.itemId == "all") {
				state.current.cat = item;
				state.search.cat = item;
				state.result.cat = item;
				state.upload.cat = item;
			}
		}

		state.upload.art = new Classes.ArtRec();
		state.current.art = new Classes.ArtRec();

		// TEMP format demo record
		// state.current.art = Utils.formatIncomingRec(CfgAppDemo.artRec, state.cats);
		// state.current.cat = state.current.art.cat;
		// m("TEMP setting demo current art", state.current.art);
		// TEMP format demo record

		// Everything is ready
		state.ready = true;
	}


}

// ACTIONS #######################################################

const actions = {

	toggleDebugConsoleMess: ({commit, dispatch}, payload) => {
		m("app act toggle debug console mess");
		commit("mutToggleDebugConsoleMess");
	},

	toggleRole: ({commit, dispatch}, payload) => {
		m("app act toggle role");
		commit("mutToggleRole");
	},

	setContact: ({ commit, dispatch}, payload) => {
		m("app act set contact", payload);
		commit("mutSetContact", payload);
	},

	updTrxStatus: ({ commit, dispatch}, payload) => {
		m("app act upd trx status", payload);
		commit("mutUpdTrxStatus", payload);
	},

	postComplete: ({ commit, dispatch}, payload) => {
		m("app act post complete", payload);
		
		// Save response messages
		commit("mutUpdTrxStatus", payload);

		// Completed Uploaded
		if (payload.step=="upload") {
		
			// Clear article
			const dataStep = {
				step: payload.step,
			}

			// Automatically Search, to show user's new article
			const dataSearch = {
				cat: state.cats[0],
				keyword: "",
				dateBeg: "",
				dateEnd: "",
			}
	
			commit("mutClearStep", dataStep);
			commit("mutSetSearch", dataSearch);
			commit("mutSetPager", {curPage:1});
			dispatch('app/reqArticles', null, { root: true });

		}


		// Completed Admin Edit
		if (payload.step=="current") {
			
			// Automatically Search same crit
			dispatch('app/reqArticles', null, { root: true });

		}


		// Clear message
		if (payload.step=="contact") {
			const dataContact = {
				rec: {},
			}
			commit("mutSetContact", dataContact);
		}

		// Save statistics
		if (payload.step=="stats") {
			const dataStats = {
				cols: payload.cols,
				rows: payload.rows,
			}
			commit("mutSetStats", dataStats);
		
		}

	},


	// Validate file chosen, upload and start event chain
	uploadPic: ({commit, dispatch}, payload) => {
		m("app act upload pic beg, files:", payload);
		if (payload.files.length === 1) {
			let file = payload.files[0];
			let answer = PixUtils.validatePicFile(file);
			if (answer.ok) {
				let rec = new Classes.PicRec();
				rec.origName = file.name;
				rec.type = file.type;
				rec.step = "upload";
				PixUtils.uploadFile(file, rec);
			} else {
				Utils.showPopMess("Invalid File", "err", answer.mess);
			}
		}
		m("app act upload pic end");
	},


	addPicRec:  ({commit, dispatch}, payload) => {
		m("app act add pic rec:", payload);
		commit("mutAddPicRec", payload);
		commit("mutCalcSortKeys", payload);
	},

	// Delete Pic by Index
	delPic: ({commit, dispatch}, payload) => {
		commit("mutDelPic", payload);
		commit("mutCalcSortKeys", payload);
		commit("mutCalcPrimaryPic", payload);
	},

	// Change Pix Order
	movePic: ({commit, dispatch}, payload) => {
		m("app act move pic", payload);
		commit("mutMovePic", payload);
		commit("mutCalcSortKeys", payload);
	},

	// TEST 
	goTest: ({commit, dispatch}, payload={}) => {
		m("app act gotest", payload);
		const { rec } = payload;
		// let rec = {...payload.rec};
		// let rec = new Classes.PicRec(state.upload.pix[idx]);
		m("rec", rec);
		
		// rec.testObj.updTime = Utils.getNow();
		let data = {
			step: rec.step,
			rec:rec,
		}
		commit("mutUpdPicRec", data);

	},

	// Rotate Pic
	rotatePic: ({commit, dispatch}, payload) => {
		m("app act rotate pic", payload);
		const {step, idx} = payload;
		let rec = new Classes.PicRec(state[step].pix[idx]);
		// rec.imgIdx = idx;
		rec.rot = (rec.rot<270)? rec.rot+90: 0;
		PixUtils.goRotate(rec);

	},

	// Update Pic Rec
	updPicRec: ({commit, dispatch}, payload) => {
		m("app act update pic", payload);
		commit("mutUpdPicRec", payload);
	},

	// Set Pic Record Flag
	clickCheckFlag: ({commit, dispatch}, payload) => {
		m("app act set pic flag", payload);
		commit("mutSetPicFlag", payload);
		commit("mutCalcPrimaryPic", payload);
	},

	// Set Animal Values
	setAnimal: ({commit, dispatch}, payload) => {
		m("app act set animal", payload);
		commit("mutSetAnimal", payload);
	},

	// Set Pager Values
	setPager: ({commit, dispatch}, payload) => {
		m("app act set pager", payload);
		commit("mutSetPager", payload);
	},

	// Set New Search Values
	setSearch: ({commit, dispatch}, payload) => {
		m("app act set search", payload);
		commit("mutSetSearch", payload);
	},

	// Set New Search Result Values
	setSearchResult: ({commit, dispatch}, payload) => {
		m("app act set search result", payload);
		commit("mutSetSearchResult", payload);
		commit("mutSetPager", {curPage:1});
	},

	// ACT Load Pix List from Recordset 
	loadPix: ({commit, dispatch}, payload) => {
		m("app act load pix", payload);
		commit("mutLoadPix", payload);
		commit("mutCalcPrimaryPic", payload);
	},

	// Act Request Sweep Messages
	reqStats: ({commit, dispatch}, payload) => {
		m("app act req stats");

		// Clear Post messages
		const dataTrxClear = {
			trx: "clear",
		}
		commit("mutUpdTrxStatus", dataTrxClear);

		// Init Post messages
		const dataTrx = {
			step: "stats",
			trx: "wait",
			mess: ["Collecting statistics..."]
		}
		commit("mutUpdTrxStatus", dataTrx);

		// Clear Stats store data
		const dataStats = {
			cols: [],
			rows: [],
		}
		commit("mutSetStats", dataStats);


		// Build and Post Request
		const data = {
			form_name	: 'site_stats',
		}

		m("data", data);

		dispatch('api/sendRequest', data, { root: true });

		m("end");
	},

	// Act Request Sweep Messages
	reqSweep: ({commit, dispatch}, payload) => {
		m("app act req sweep");

		// Clear Post messages
		const dataTrxClear = {
			trx: "clear",
		}
		commit("mutUpdTrxStatus", dataTrxClear);

		const dataTrx = {
			step: "sweep",
			trx: "wait",
			mess: ["Sweeping messages..."]
		}
		commit("mutUpdTrxStatus", dataTrx);
		
		// Build and Post Request
		const data = {
			form_name	: 'mail_sweep',
		}

		m("data", data);

		m("ready to send request, left off here")
		dispatch('api/sendRequest', data, { root: true });

	},

	// Act Post Contact Message 
	reqPostContact: ({commit, dispatch}, payload) => {
		m("app act req post contact");
		
		// Clear Post messages
		let dataTrxClear = {
			trx: "clear",
		}
		commit("mutUpdTrxStatus", dataTrxClear);

		const dataTrx = {
			step: "contact",
			trx: "wait",
			mess: ["Sending your message..."]
		}
		commit("mutUpdTrxStatus", dataTrx);
		
		// Build and Post Request
		const data = {
			form_name	: 'mess_post',
			full_name	: state.contact.name,
			email_from	: state.contact.email,
			subject		: state.contact.subj,
			mess_text	: state.contact.messText,
			send_copy	: 0,
		}

		m("data", data);
		dispatch('api/sendRequest', data, { root: true });
	},

	// Act Post new Article
	reqPostArt: ({commit, dispatch}, payload) => {
		m("app act req post art");

		// Clear Post messages
		let dataTrx = {
			trx: "clear",
		}
		commit("mutUpdTrxStatus", dataTrx);

		dataTrx = {
			step: "upload!",
			trx: "wait",
			mess: ["Uploading your article..."]
		}
		commit("mutUpdTrxStatus", dataTrx);

		// Build and Post Request
		const len = state.upload.pix.length;
		const data = {
			form_name: 'art_post',
			cat_id: state.upload.cat.itemId,
			art_title: state.upload.art.title,
			art_credit: state.upload.art.credit,
			art_story: state.upload.art.fullTxt,
			main_idx: state.upload.art.mainIdx,
			img_name_00: (len<1)? '': state.upload.pix[0].origName,
			img_data_00: (len<1)? '': state.upload.pix[0].imgs.max,
			img_name_01: (len<2)? '': state.upload.pix[1].origName,
			img_data_01: (len<2)? '': state.upload.pix[1].imgs.max,
			img_name_02: (len<3)? '': state.upload.pix[2].origName,
			img_data_02: (len<3)? '': state.upload.pix[2].imgs.max,
			attn: 'art_post' 
		}

		m("data", data);

		dispatch('api/sendRequest', data, { root: true });

	},


	// Act Request Update Article
	reqUpdateArt: ({commit, dispatch}, payload) => {
		m("app act req update art");

		// Clear Post messages
		const dataTrxClear = {
			trx: "clear",
		}
		commit("mutUpdTrxStatus", dataTrxClear);

		const dataTrx = {
			step: "current",
			trx: "wait",
			mess: ["Updating article..."]
		}
		commit("mutUpdTrxStatus", dataTrx);

		const artObj = ApiUtils.buildArtObject(state.current.art);
		const pixObj = ApiUtils.buildPixObject(state.current.pix);

		const data = {
			form_name	: 'adm_save',
			art			: JSON.stringify(artObj),
			pix			: JSON.stringify(pixObj),
			prop_val	: 'brillz_attom' ,
		};

		if (state.current.art.dateVis!="no date") {
			data.date_cre = state.current.art.dateCre;
		}

		m('art', artObj);
		m('pix', pixObj);
		m('dat', data);

		m("ready to post");

		dispatch('api/sendRequest', data, { root: true });




		m("left off here");




	},


	// ACT Request Article Images
	reqArtPix: ({commit, dispatch}, payload) => {
		m("app act req art pix");
		commit("mutLoadPix"); // clear current pix list

		const data = {
			form_name: "art_pix",
			art_id: state.current.art.itemId,
			view: (state.role=="adm")? "full": "",
		}

		m("app store: request pix", data);
		dispatch('api/sendRequest', data, { root: true });

	},


	// Request Articles 
	reqArticles: ({ commit, dispatch }, payload ) => {

		commit("mutLoadArts"); // clear arts list

		const pageData = {
			begRec: 0,
			endRec: 0,
			qtyRecs: 0,
			totRecs: 0,
		}; 
		commit("mutSetPager", pageData);

		const data = {
			form_name: "arts_list",
			cat_id: state.result.cat.itemId,
			page: state.pager.curPage,
			view: (state.role=="adm")? "full": "",
		}

		if (state.result.keyword!="") data.keyword = state.result.keyword;
		if (state.result.dateBeg != "") data.date_from = state.result.dateBeg;
		if (state.result.dateEnd != "") data.date_to = state.result.dateEnd;

		m("app store: request articles", data);
		dispatch('api/sendRequest', data, { root: true });
	
	},


	// Set Article
	setArt: ({ commit , dispatch }, payload) => {
		m("app act set art", payload);
		commit("mutSetArt", payload);
	},


	// Set Category 
	setCat: ({ commit , dispatch }, payload) => {
		m("store app set cat", payload);
		commit("mutSetCat", payload);
	},


	// Check if ready, initialize
	checkReady: ({commit, dispatch}, payload) => {
		m("app act checkready");
		
		m("state", state);
		let ok = true;
		for (let task_id of CfgApp.initTasks) {
			if (!state.initTasksPassed.includes(task_id)) ok = false;
			m("task_id: " + task_id + ", ok: " + ok);
		}
		if (ok) {
			commit("mutInit");
		}
	},

	// Load categories from results set
	loadCats: ({ commit , dispatch }, payload) => {
		m("store app load cats", payload);
		commit("mutLoadCats", payload);
		commit("mutInitTaskPass", "init_cats_list");
		dispatch("checkReady");
	},

	// Load Articles from results set
	loadArts: ({ commit , dispatch }, payload) => {
		m("app act load arts", payload);
		commit("mutLoadArts", payload);
	},

	// Set init task complete
	initTaskPass: ({ commit, dispatch }, task_id) => {
		m("store app init task pass: " + task_id);
		commit("mutInitTaskPass", task_id);
	},	


}


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}